import type React from 'react';

import { cn } from '@/lib/utils';

interface HeaderRootProps extends React.HTMLAttributes<HTMLElement> {
  isHomepage?: boolean;
}

const HeaderRoot = ({ children }) => (
  <header className={cn('w-full')}>{children}</header>
);

const MainHeaderRoot = ({ children, isHomepage }: HeaderRootProps) => (
  <div
    className={cn(
      'flex h-[60px] w-full flex-row items-center justify-between bg-white pr-4 pl-1',
      isHomepage && 'border-gray-200 border-b border-solid'
    )}
  >
    {children}
  </div>
);

const HeaderDivider = () => <p className="pr-1 pl-0 text-gray-200">/</p>;

const HeaderLeft = ({ children }) => (
  <div className="z-[100] flex flex-row items-center">{children}</div>
);

const HeaderRight = ({ children }) => (
  <div className="flex space-x-3">{children}</div>
);

const HeaderMenu = ({ children }) => (
  <div className="m-1 flex select-none flex-row items-center gap-x-2">
    {children}
  </div>
);

const HeaderMenuItem = ({ children }) => (
  <div className="flex cursor-pointer select-none flex-row items-center">
    {children}
  </div>
);

interface HeaderMenuItemProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  onClick: () => void;
}
const HeaderMenuItemLink = ({ children, onClick }: HeaderMenuItemProps) => (
  <div
    className="flex w-full cursor-pointer select-none flex-row items-center gap-x-3 rounded-sm py-1 pl-2"
    onClick={onClick}
  >
    {children}
  </div>
);

const HeaderMenuItemLabel = ({ children }) => (
  <p className="text-center font-semibold text-gray-700 text-sm">{children}</p>
);

const EnvironmentSpan = ({ children }) => (
  <span className="ml-3 w-max select-none rounded-lg bg-gradient-to-r from-[#4b35d2] to-[#5246f7] px-3 font-semibold text-sm text-white leading-5 tracking-wide">
    {children}
  </span>
);

const ProcessList = ({ children }) => (
  <div className="max-h-[400px] overflow-auto">{children}</div>
);

const CustomMenuItem = ({ children }) => (
  <div className="flex cursor-pointer items-center gap-[10px] px-[10px] py-[5px] hover:bg-[#f0f4f8]">
    {children}
  </div>
);

export {
  HeaderRoot,
  MainHeaderRoot,
  HeaderDivider,
  HeaderLeft,
  HeaderRight,
  HeaderMenu,
  HeaderMenuItem,
  HeaderMenuItemLink,
  HeaderMenuItemLabel,
  EnvironmentSpan,
  CustomMenuItem,
  ProcessList
};
